import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Button, Input } from '@node-space/ui-components'

interface RewardsAmountInputProps {
  selectedCurrency: string
  maxAmount: number
  disabled?: boolean
  label?: string
  placeholderText?: string
  testId?: string
}

export const RewardsAmountInput: React.FC<RewardsAmountInputProps> = ({
  selectedCurrency,
  maxAmount,
  disabled = false,
  label,
  placeholderText = '0.00',
  testId = 'amount-input',
}) => {
  const { t } = useTranslation()
  const { control } = useFormContext()

  const displayLabel = label || t('amount')

  return (
    <Controller
      control={control}
      name="amount"
      render={({ field, fieldState: { error } }) => (
        <Input
          {...field}
          testId={testId}
          label={displayLabel}
          disabled={disabled}
          placeholderText={placeholderText}
          helperText={t('rewards.withdraw.maxAmount', {
            amount: `${maxAmount || '-'} ${selectedCurrency}`,
          })}
          rightSuffixText={selectedCurrency}
          LabelButton={
            <Button
              variant="ghost"
              disabled={maxAmount <= 0}
              onClick={() => {
                field.onChange(maxAmount.toString())
              }}
            >
              {t('max')}
            </Button>
          }
          error={!!error?.message}
          errorText={error?.message}
        />
      )}
    />
  )
}
